module.exports = __webpack_public_path__ + "img/camiansaintlogo.4e791ff7.png";